import React, { PureComponent, createRef } from 'react';

import { ThemeContext } from 'utils/theme';

import Wrapper from './styled/Wrapper';
import Video from './styled/Video';
import { Iframe, IFrameContainer } from './styled/Iframe';
import debounce from 'lodash/debounce';

export default class GallerySection extends PureComponent {
  static contextType = ThemeContext;

  constructor(props) {
    super(props);

    this.wrapRef = createRef();
  }

  state = {
    isVimeoVideo: false,
    vimeoUrl: '',
  };

  componentDidMount() {
    if (this.props.url) {
      if (this.props.url.includes('vimeo')) {
        this.setState({ isVimeoVideo: true });
        const videoNumberPart = this.props.url.split('vimeo.com/')[1];
        const videoNumber = videoNumberPart.split('?')[0];
        this.setState({ vimeoUrl: videoNumber });
      }
    }

    setTimeout(() => {
      this.checkElementHeight();
    }, 2000);

    window.addEventListener('resize', debounce(this.onResize, 300));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.checkElementHeight();
  };

  checkElementHeight = () => {
    if (this.wrapRef.current) {
      const elementHeight = this.wrapRef.current.clientHeight;
      this.props.heightSetter(elementHeight);
    }
  };

  render() {
    const { url, media } = this.props;
    const { isVimeoVideo, vimeoUrl } = this.state;

    return (
      <Wrapper ref={this.wrapRef}>
        {isVimeoVideo ? (
          <IFrameContainer>
            <Iframe
              title="vimeo-player"
              src={`https://player.vimeo.com/video/${vimeoUrl}?title=0&byline=0&portrait=0&sidedock=0&transparent=0`}
              frameborder="0"
              webkitAllowFullScreen
              mozallowfullscreen
              allowFullScreen
            />
          </IFrameContainer>
        ) : (
          <Video muted autoPlay controls src={url || media.url} />
        )}
      </Wrapper>
    );
  }
}
